module.exports = __webpack_public_path__ + "img/3.9941ed12.jpg";